<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true">
        {{getCellSummary(dataItem)}}
    </span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-dietary-indicator-multi-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)"
                                                     [multiObjectValueType]="multiObjectValueType"
                                                     [formControl]="formGroup.get(field)"
                                                     [attr.id]="elementId"
                                                     [viewFilter]="viewFilter"
                                                     (valueChange)="controlValueChange($event, dataItem, formGroup)"
                                                     [placeholder]="getPlaceholder(dataItem)">
    </wbo-dietary-indicator-multi-select-edit-control>
</ng-template>
